export default "__VITE_ASSET___0WnbwHt__"